import React from 'react';

const FranchiseSetting = () => {

    const [formData, setFormData] = React.useState({});

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };


    return (
        <>
            <div className="section ">
                <div className="">
                    <div style={{
                        background: "var(--surface)",
                        border: "1px solid var(--border)",
                        borderRadius: "0px 0px 14px 14px",
                        padding: "20px 22px",
                    }}>
                        <div style={{ marginBottom: 16 }}>
                            <h3 style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 700, color: "var(--text)", margin: 0 }}>Franchise Settings</h3>
                            <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>Update your franchise information</p>
                        </div>


                        <div className="oms-form-grid">


                            <div className="oms-form-group">
                                <label className="oms-form-label">Company Name</label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter company name"
                                    value={formData.companyName || ""}
                                    onChange={(e) =>
                                        handleChange("companyName", e.target.value)
                                    }
                                />
                            </div>


                            <div className="oms-form-group">
                                <label className="oms-form-label">CNIC</label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter CNIC number"
                                    value={formData.cnic || ""}
                                    onChange={(e) =>
                                        handleChange("cnic", e.target.value)
                                    }
                                />
                            </div>

                            <div className="oms-form-group">
                                <label className="oms-form-label">Contact</label>
                                <input
                                    className="oms-form-input"
                                    placeholder="Enter contact number"
                                    value={formData.contact || ""}
                                    onChange={(e) =>
                                        handleChange("contact", e.target.value)
                                    }
                                />
                            </div>

                        </div>

                        <div className='mt-3 text-end '>
                            <button
                                className='oms-btn oms-btn-primary'
                                size='sm'
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default FranchiseSetting